import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

    content: [],
    UserFeeds: {
      items: [
        {
          id: 'news', name: 'Nachrichten', path: 'news', isUserDefined: false, urls: []
        },
        {
          id: 'sport', name: 'Sport', path: 'sport', isUserDefined: false, urls: []
        },
        {
          id: 'technik', name: 'Technik', path: 'technik', isUserDefined: false, urls: []
        },
        {
          id: 'lifestyle', name: 'Lifestyle', path: 'lifestyle', isUserDefined: false, urls: []
        },
        {
          id: 'wirtschaft', name: 'Wirtschaft', path: 'wirtschaft', isUserDefined: false, urls: []
        },
        {
          id: 'deals', name: 'Deals', path: 'deals', isUserDefined: false, urls: []
        },
      ]
    },
    StaticFeeds: {
      items: [
      ]
    }
  },
  mutations: {
    setStaticFeeds(state, aContent) {
      state.StaticFeeds.items = aContent;
    },
    setUserFeeds(state, aContent) {
      state.UserFeeds = aContent;
    },
    clearContent(state) {
      state.content = [];
    },
    setContentItem(state, aContent) {
      // mutate state
      let existingFeed = state.content.find(function (data) {
        return data.url == aContent.url;
      })

      if (existingFeed === undefined) {
        state.content.push(aContent);
      }
      else {
        existingFeed.nextPageNo = aContent.nextPageNo;
        existingFeed.nextPageGuid = aContent.nextPageGuid;
        existingFeed.feed = existingFeed.feed.concat(aContent.feed);
      }

    },
    addUserFeed(state, newFeed) {
      // TODO Methode erstellen START
      let existingCategory = state.UserFeeds.items.find(function (data) {
        return data.id == newFeed.categoryId;
      });

      if (existingCategory === undefined) {
        existingCategory = { id: newFeed.categoryId, name: newFeed.category, path: newFeed.categoryId, isUserDefined: true, urls: [] };
        state.UserFeeds.items.push(existingCategory);
      }
      // TODO Methode erstellen ENDE

      // TODO homepage url parsen
      //let homepage = newFeed.homepage;

      let id = 1;
      if (existingCategory.urls.length > 0)
        id = existingCategory.urls[existingCategory.urls.length - 1].id + 1;

      //existingCategory.urls.push({ id: id, name: newFeed.name, type: newFeed.type, homepage: homepage, icon: newFeed.icon, url: newFeed.url });
      newFeed.id = id;
      existingCategory.urls.push(newFeed);

    },
    editUserFeed(state, editedFeed) {
      //let updatedFeed = { id: editedFeed.id, name: editedFeed.name, type: editedFeed.type, homepage: editedFeed.homepage, icon: editedFeed.icon, url: editedFeed.url };
      let category = state.UserFeeds.items[editedFeed.indexCategory];
      //Gleiche Categoey
      if (category.id == editedFeed.categoryId) {
        category.urls.splice(editedFeed.indexFeed, 1, editedFeed);
      }
      //Kategorie geändert
      else {

        // TODO deleteUserCategory aufrufen
        category.urls.splice(editedFeed.indexFeed, 1);
        if (category.isUserDefined && category.urls.length == 0) {
          state.UserFeeds.items.splice(editedFeed.indexCategory, 1);
        }

        // TODO Methode erstellen START
        let existingCategory = state.UserFeeds.items.find(function (data) {
          return data.id == editedFeed.categoryId;
        });

        if (existingCategory === undefined) {

          existingCategory = { id: editedFeed.categoryId, name: editedFeed.category, path: editedFeed.categoryId, isUserDefined: true, urls: [] };
          state.UserFeeds.items.push(existingCategory);
        }

        editedFeed.id = 1;
        if (existingCategory.urls.length > 0)
        editedFeed.id = existingCategory.urls[existingCategory.urls.length - 1].id + 1;
        // TODO Methode erstellen ENDE

        existingCategory.urls.push(editedFeed);
      }
    },
    deleteUserFeed(state, deletedFeed) {
      let category = state.UserFeeds.items[deletedFeed.indexCategory];
      category.urls.splice(deletedFeed.indexFeed, 1);
      if (category.isUserDefined && category.urls.length == 0) {
        state.UserFeeds.items.splice(deletedFeed.indexCategory, 1);
      }
    },
  },
  actions: {
    loadStaticFeeds({ commit }, staticFeeds) {
      commit('setStaticFeeds', staticFeeds);
    },
    addUserFeed({ commit, dispatch }, newFeed) {
      return new Promise(resolve => {
        commit('addUserFeed', newFeed)
        dispatch('saveUserFeeds')
        resolve();
      });
    },
    editUserFeed({ commit, dispatch }, editedFeed) {
      return new Promise(resolve => {
        commit('editUserFeed', editedFeed)
        dispatch('saveUserFeeds')
        resolve();
      });
    },
    deleteUserFeed({ commit, dispatch }, deletedFeed) {
      return new Promise(resolve => {
        commit('deleteUserFeed', deletedFeed);
        dispatch('saveUserFeeds');
        resolve();
      });

    },
    saveUserFeeds({ state }) {
      localStorage.setItem('UserFeeds', JSON.stringify(state.UserFeeds))
    },
    loadUserFeeds({ state, commit }) {
      let userFeeds = state.UserFeeds;
      if (window.localStorage.getItem('UserFeeds')) {
        userFeeds = JSON.parse(window.localStorage.getItem('UserFeeds'));
      }
      //state.UserFeeds = userFeeds;
      commit('setUserFeeds', userFeeds);
    },
    async setContent(context, aContent) {
      await context.commit('setContentItem', aContent);
    },
    clearContent(context) {
      context.commit('clearContent');
    }

  }
})
